import type { NavBarConfig } from '@gm-commercial/navbar-model';

/**
 * Removes nav items whose `path` is empty (e.g. after `makeRoutePathLite` cleared a feature-gated route).
 * @param config - Nav bar config from `getNavDrawerConfig` (mutates nested `children` arrays in place).
 * @returns A shallow copy of `config` with a filtered `items` list.
 */
export const sanitizeNavDrawerConfig = (config: NavBarConfig): NavBarConfig => {
  return {
    ...config,
    items: config.items.filter((item) => {
      if (item.path === '') {
        return false;
      }

      if (item.children) {
        item.children = sanitizeNavDrawerConfig({
          items: item.children,
        }).items;
      }

      return true;
    }),
  };
};
